













import Vue, { PropType } from 'vue';
// import { BoothData } from '@/modules/exhibitor/booth';
// import { Story } from '@/modules/exhibitor/story';

import {
  Booth,
} from 'mostra';
// import {
//   Story,
//   BoothData,
// } from 'mostra';
// import { v4 } from 'uuid';
//
// const addButtonSelectMenu = [
//   { value: 'StoryTitle', text: 'タイトル・見出し' },
//   { value: 'StoryDescription', text: '本文' },
//   { value: 'StoryImage', text: '画像' },
//   { value: 'StoryVideo', text: 'YouTube動画' },
// ];
//
// const generateListKey = () => v4();
//
// type BoothStoryItem = {
//   id: string,
//   story: Story,
// }

export default Vue.extend({
  name: 'GBoothStoryForm',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    booth: {
      type: Object as PropType<Booth>,
    },
  },
  // data() {
  //   return {
  //     addButtonSelectMenu: addButtonSelectMenu,
  //   };
  // },
  // computed: {
  //   stories(): BoothStoryItem[] {
  //     return this.booth.stories.map((story: Story) => (
  //       {
  //         id: generateListKey(),
  //         story: story,
  //       }
  //     ));
  //   },
  // },
});
